<!--
  @Description: 活动详情页
  @Author: wang.y 
  @Date: 2022-04-18 
-->
<template>
  <div class="detail-container">
    <Breadcrumb separator=">" class="breadcrumb_zdy">
      当前位置:
      <BreadcrumbItem :to="{name: 'ActList'}">活动</BreadcrumbItem>
      <BreadcrumbItem>活动详情</BreadcrumbItem>
    </Breadcrumb>
    <div class="detail">
      <Spin fix v-if="loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      <div class="detail-top">
        <div class="detail-img">
          <img :src="detail.image_path | logo_show" v-if="detail.image_path" />
          <p v-else>暂无封面</p>
        </div>
        <div class="detail-info">
          <div class="activity-info-item">
            <div class="lt">活动名称</div>
            <div class="rt">
              <div class="cnt">{{detail.name}}</div>
            </div>
          </div>
          <div class="activity-info-item">
            <div class="lt">活动时间</div>
            <div class="rt">
              <div class="cnt">{{detail.begin_time}}</div>
            </div>
          </div>
          <div class="activity-info-item">
            <div class="lt">举办地点</div>
            <div class="rt">
              <div class="cnt">
                <span v-if="detail.province">{{detail.province}}</span>
                <span v-if="detail.city">{{detail.city}}</span>
                <span v-if="detail.address">{{detail.address}}</span>
              </div>
            </div>
          </div>
          <div class="activity-info-item">
            <div class="lt">活动规模</div>
            <div class="rt">
              <div class="cnt">{{detail.number}}人</div>
            </div>
          </div>
          <div class="activity-info-item">
            <div class="lt">付费类型</div>
            <div class="rt">
              <div class="cnt">{{detail.is_free == '0' ? '付费' : '免费'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-bottom">
        <div class="activity-title">{{detail.name}}</div>
        <div class="activity-time">{{detail.begin_time}}</div>
        <div class="activity-content" v-html="detail.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getActById } from '@/service'
export default {
  components: {},
  created() {
    this.getActById()
  },
  data() {
    return {
      loading: true,
      detail: {}
    }
  },
  methods: {
    /**
     * 获取活动详情
     */
    async getActById() {
      let res = await getActById(
        {
          uid: this.$route.params.uid,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.loading = false
      if (res.status == 'success') {
        this.$set(this.$data, 'detail', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common.stylus'
.detail-container
  width 1200px
  margin 0 auto
  padding 16px 0 20px
  .detail
    margin 20px auto
    width 1000px
    position relative
    >>> .ivu-spin
      background #f4f6f8
    >>> .ivu-spin-main
      top calc(50vh - 64px)
  .detail-top
    display flex
    .detail-img
      height 196px
      width 330px
      background-color #FCFCFC
      display flex
      align-items center
      justify-content center
      img
        width 100%
        height 100%
      p
        color #999
    .detail-info
      flex 1
      margin-left 20px
      .activity-info-item
        display flex
        height 38px
        &+div
          margin-top 1px
        .lt
          width 170px
          background-color #FFFAF5
          display flex
          align-items center
          justify-content center
        .rt
          flex 1
          background-color #FCFCFC
          padding 0 20px
          display flex
          align-items center
          .cnt
            ellipsisClamp2()
            line-height 18px
            span+span
              margin-left 10px
  .detail-bottom
    padding 40px 80px
    background-color #fff
    margin-top 20px
    .activity-title
      font-size 28px
      line-height 36px
      text-align center
      font-weight bold
    .activity-time
      color #999
      text-align center
      margin-top 20px
    .activity-content
      font-size 14px
      line-height 28px
      margin-top 30px
      >>> img
        max-width 100%
</style>